
		<br>
		<div class="row ul-margin-bottom">
			<div class="col-md-12">
				<nav class="nav nav-pills">
					<ng-container *ngFor="let p of periodList">
						<a
							[class]="p == periodService.period ? 'period-tab text-sm-center nav-link active' : 'period-tab text-sm-center nav-link'"
							[routerLink]="['/' + baseUrl]" [queryParams]="getQueryParams(p)"
							[attr.tab]="p"
						>
							{{ 'adminstat.filterForm.' + p | translate }}
						</a>	  
					</ng-container>
				</nav>
			</div>
		</div>
	